/**
 * Up to two letters for an avatar: the first letters of the first two words ("Andrew Smith" → "AS",
 * "Brave Hardy (Pty) Ltd" → "BH"), one letter for one word, the part before the @ of an email
 * ("andrew.smith@…" → "AS"), and "?" for no name. The Chrome extension borrows this file.
 */
export function initials(name: string | null | undefined): string {
  let text = (name ?? '').trim();
  if (!/\s/.test(text) && text.includes('@')) text = text.slice(0, text.indexOf('@'));
  // Words that start with a letter or digit, so "(Pty)" and "&" don't count.
  const words = text.split(/[\s._-]+/).filter((word) => /^[\p{L}\p{N}]/u.test(word));
  if (!words.length) return '?';
  return words
    .slice(0, 2)
    .map((word) => Array.from(word)[0])
    .join('')
    .toUpperCase();
}
